/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CommentReactionSummary from './CommentReactionSummary';

/**
 * The CommentResponse model module.
 * @module model/CommentResponse
 * @version V1
 */
class CommentResponse {
    /**
     * Constructs a new <code>CommentResponse</code>.
     * @alias module:model/CommentResponse
     */
    constructor() { 
        
        CommentResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommentResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommentResponse} obj Optional instance to populate.
     * @return {module:model/CommentResponse} The populated <code>CommentResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommentResponse();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
            if (data.hasOwnProperty('commentedBy')) {
                obj['commentedBy'] = ApiClient.convertToType(data['commentedBy'], 'Number');
            }
            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('reactions')) {
                obj['reactions'] = ApiClient.convertToType(data['reactions'], [CommentReactionSummary]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommentResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommentResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['comment'] && !(typeof data['comment'] === 'string' || data['comment'] instanceof String)) {
            throw new Error("Expected the field `comment` to be a primitive type in the JSON string but got " + data['comment']);
        }
        if (data['reactions']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['reactions'])) {
                throw new Error("Expected the field `reactions` to be an array in the JSON data but got " + data['reactions']);
            }
            // validate the optional field `reactions` (array)
            for (const item of data['reactions']) {
                CommentReactionSummary.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
CommentResponse.prototype['id'] = undefined;

/**
 * @member {String} comment
 */
CommentResponse.prototype['comment'] = undefined;

/**
 * @member {Number} commentedBy
 */
CommentResponse.prototype['commentedBy'] = undefined;

/**
 * @member {Number} jobId
 */
CommentResponse.prototype['jobId'] = undefined;

/**
 * @member {Date} createdAt
 */
CommentResponse.prototype['createdAt'] = undefined;

/**
 * @member {Array.<module:model/CommentReactionSummary>} reactions
 */
CommentResponse.prototype['reactions'] = undefined;






export default CommentResponse;

